export const ZoneRecord = {
  methods: {
    sendData () {
      this.$nextTick(() => {
        this.$emit('send-data', this.model)
      })
    }
  }
}
